import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import MarketingLayout from "@/components/MarketingLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowWeWork from "@/pages/HowWeWork";
import Packages from "@/pages/Packages";
import IndividualServices from "@/pages/IndividualServices";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Brochure from "@/pages/Brochure";
import Terms from "@/pages/legal/Terms";
import NDA from "@/pages/legal/NDA";
import Privacy from "@/pages/legal/Privacy";
import Cookies from "@/pages/legal/Cookies";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContent from "@/pages/admin/AdminContent";
import AdminChats from "@/pages/admin/AdminChats";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminSecurityLogs from "@/pages/admin/AdminSecurityLogs";
import AdminSessions from "@/pages/admin/AdminSessions";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSetup from "@/pages/admin/AdminSetup";
import AdminPasswordReset from "@/pages/admin/AdminPasswordReset";
import AdminMfaReset from "@/pages/admin/AdminMfaReset";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/individual-services" element={<IndividualServices />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/brochure" element={<Brochure />} />
            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/nda" element={<NDA />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/cookies" element={<Cookies />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin/password-reset" element={<AdminPasswordReset />} />
          <Route path="/admin/mfa-reset" element={<AdminMfaReset />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route
              path="content"
              element={
                <ProtectedRoute roles={["super_admin", "admin"]}>
                  <AdminContent />
                </ProtectedRoute>
              }
            />
            <Route path="chats" element={<AdminChats />} />
            <Route path="security" element={<AdminSecurity />} />
            <Route
              path="security/logs"
              element={
                <ProtectedRoute roles={["super_admin", "admin"]}>
                  <AdminSecurityLogs />
                </ProtectedRoute>
              }
            />
            <Route path="security/sessions" element={<AdminSessions />} />
            <Route
              path="security/users"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
